import { ERP } from '../_base/endpoint';
import axios from 'axios';

class tipoRegimenService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/tipo-regimen`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new tipoRegimenService();